export const LAST_SEEN = 'user_last_seen';
export const DEMO_TIP_SHOW = 'is_demo_tips_show';
export const FLOW_EXPLAIN = 'flow_explain';
export const USER_GUIDE_LAYOUT = 'user_guide_layout';
export const USER_GUIDE_TOGGLE = 'user_guide_toggle';
export const USER_GUIDE_TARGETING = 'user_guide_targeting';
export const USER_GUIDE_PROJECT = 'user_guide_project';
export const USER_GUIDE_TRACK_EVENT = 'user_guide_track_event';